import type { RouteRecordRaw } from 'vue-router';
import { useBrandComponent } from '@/composables/useBrandComponent';

/**
 * Ruta del módulo Mi Perfil v2.
 *
 * ✅  SWITCH DE MENÚ HECHO (backlog 5, carril B).
 *     Registrada append-only en `/private/profile-v2`. El ítem "Perfil" del menú
 *     v2 (sidebar `MenuPerfilV2.vue` y dropdown `ProfileDDV2.vue`) ya apunta a
 *     esta vista (`{ name: 'Mi Perfil v2' }`) — un módulo, un switch.
 *     La ruta v1 `/private/profile` (name `Profile`,
 *     `views/private/user/profile/Profile.vue`) se conserva intacta.
 *     Revertir = volver a apuntar esos dos componentes a `{ name: 'Profile' }`;
 *     no se borra nada de v1.
 *
 * ── REGLA 2 — cómo se carga la vista ────────────────────────────────────────
 * Se resuelve con `useBrandComponent`, NUNCA con `import()` directo, para que una
 * marca pueda sustituirla con su propio
 * `brand/src/modules/profile-v2/views/ProfileView.vue`.
 *
 * ── REGLA 3 — filtra EXACTAMENTE igual que la v1 que sustituye ───────────────
 * Mismos `requiresPermission` / `minLevel` / `requiresSystemPermission` que la
 * ruta v1 `/private/profile` (name `Profile`): `brokerin` · 20 · `profile`
 * (`src/router/PrivateRoutes.ts`). Si no, un usuario sin el permiso entraría a una
 * pantalla a la que hoy no tiene acceso.
 */
export const profileRoutes: RouteRecordRaw[] = [
    {
        // path relativo, se cuelga de `/private` desde PrivateRoutes.ts → /private/profile-v2
        path: 'profile-v2',
        name: 'Mi Perfil v2',
        component: useBrandComponent('modules/profile-v2/views/ProfileView.vue'),
        meta: {
            requiresAuth: true,
            title: 'Perfil',
            requiresPermission: 'brokerin',
            minLevel: 20,
            requiresSystemPermission: 'profile'
        }
    }
];
